import { html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseElement } from '../base/base-element.js';
import type { Player } from '../../types.js';

@customElement('player-list')
export class PlayerList extends BaseElement {
    static styles = [
        BaseElement.styles,
        css`
            :host {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 0.25rem;
            }

            .player-item {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 0.25rem;
                padding: 0.25rem 0.5rem;
                background: white;
                border-radius: 4px;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                font-size: 0.75rem;
                white-space: nowrap;
            }

            .player-item.empty {
                justify-content: center;
                color: var(--text-muted, #64748b);
                font-style: italic;
                font-size: 0.7rem;
            }

            .player-id {
                font-weight: 500;
                color: var(--primary-color, #2563eb);
            }

            .player-status {
                color: var(--success-color, #10b981);
                font-size: 0.6rem;
            }
        `,
    ];

    @property({ attribute: false })
    players: Player[] = [];

    @property({ type: String })
    emptyMessage = 'No players connected yet';

    render() {
        if (this.players.length === 0) {
            return html`<div class="player-item empty">${this.emptyMessage}</div>`;
        }

        return html`${this.players.map(
            (player) => html`
                <div class="player-item">
                    <span class="player-id">${player.id}</span>
                    <span class="player-status">●</span>
                </div>
            `
        )}`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'player-list': PlayerList;
    }
}
